import React, { Suspense } from 'react'

import { Outlet } from 'react-router-dom'
import { Spinner } from '@web/walter-ui-kit'
import styles from './style.module.css'
import NoServicesBanner from '~components/NoServicesBanner'
import PageHeader from '~components/PageLayout/PageHeader'

function AuthLayout() {
    return (
        <div className={styles.root}>
            <main className={styles.content}>
                <NoServicesBanner />
                <PageHeader isAuthPage />
                <div className={styles.mainContent}>
                    <Suspense
                        fallback={
                            <div className={styles.spinner}>
                                <Spinner size={36} />
                            </div>
                        }
                    >
                        <Outlet />
                    </Suspense>
                </div>
            </main>
        </div>
    )
}

export default AuthLayout
